import bowser from 'bowser';

/*
As an approximation we consider devices running
 iOS versions 10 and lower
 Android versions 6 and lower
too old and slow
*/
export default function slowDevice() {
  return (
    (bowser.ios && parseInt(bowser.osversion, 10) < 11) ||
    (bowser.android && parseInt(bowser.osversion, 10) < 7)
  );
}
